import { render, staticRenderFns } from "./ReadQrCode.vue?vue&type=template&id=53335b27&scoped=true&"
import script from "./ReadQrCode.vue?vue&type=script&lang=js&"
export * from "./ReadQrCode.vue?vue&type=script&lang=js&"
import style0 from "./ReadQrCode.vue?vue&type=style&index=0&id=53335b27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53335b27",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCheckbox,VCol,VIcon,VRow})
